import * as model from "@/model/prd/inventoryMgt/RawMaterial";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.RawMaterial(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/inventory",
    }) //TODO load at the application start
    .withActions({
        Receive(context, entity) {
            context.dispatch("api/post", {
                url: context.state.baseModuleUrl + "/" + entity + "/receive",
                data: context.state.entity,

            }, { root: true })
                .then(function () {
                    return context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Success!",
                        dismissCountDown: 1,
                        userAlertSuccessVisible: false,
                    }, { root: true })
                }).then(function () {
                    return context.dispatch("api/get", {
                        url: context.state.baseModuleUrl + "/rawMaterial/" + "findAll"
                        // + context.state.entity.filter
                    }, { root: true })

                }).then(response => {
                    return context.commit('rawMaterial' + "/setRows", response, { root: true });
                });
        },
    })
    .buildStore()